export const KEY = {
    ARROW_UP: 'ArrowUp',
    ARROW_DOWN: 'ArrowDown',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_RIGHT: 'ArrowRight',
    HOME: 'Home',
    END: 'End',
    ENTER: 'Enter',
    ESCAPE: 'Escape',
    TAB: 'Tab',
    SPACE: ' ',
}

export const DIRECTION = {
    UP: 'up',
    DOWN: 'down',
}

export const ICON_SIZE = {
    XSMALL: 12,
    SMALL: 16,
    MEDIUM: 24,
    XLARGE: 64
}
